


































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Message, SearchCondition } from '@/modules/message';
import { MessageTypes, getMessageTypeName } from '@/enums/messageTypes';
import { PublicTypes, getPublicTypeName } from '@/enums/publicTypes';
import { ReadTypes } from '@/enums/readTypes';
import { UserTypes } from '@/enums/userTypes';

@Component
export default class LatelyMessage extends Vue {
  private MessageTypes = MessageTypes;
  private getMessageTypeName = getMessageTypeName;
  private PublicTypes = PublicTypes;
  private getPublicTypeName = getPublicTypeName;
  private UserTypes = UserTypes;

  @Prop({ default: 7 }) private days: number;

  private messages: Message[] = [];
  private loading = false;

  private condition: SearchCondition = {
    dateFrom: (this as any).$moment().add(-7, 'days'),
    dateTo: null,
    messageType: MessageTypes.All,
    publicType: PublicTypes.Public,
    readType: ReadTypes.All,
    tutorIdList: [],
    keyWord: '',
    perPage: 1000000,
    page: 1,
    sort: 'updateDate descending'
  };

  get userId() {
    if (this.$store.state.me.user == null) {
      return null;
    } else {
      return this.$store.state.me.user.id;
    }
  }

  @Watch('userId')
  private changeUserId() {
    this.loadData();
  }

  private created() {
    this.condition.dateFrom = (this as any).$moment().add(-this.days, 'days');
  }

  private mounted() {
    this.loadData();
  }

  private async loadData() {
    if (!this.userId) {
      this.messages = [];
      return;
    }

    this.loading = true;

    const data = await this.$store
      .dispatch('message/getMessages', this.condition)
      .catch((error) => {
        this.messages = [];
        this.loading = false;
        return;
      });
    this.messages = data.messageList;
    this.loading = false;
  }

  private sendDateFormatter(row: Message) {
    if (!row.sendDate) {
      return '';
    } else {
      return (this as any).$moment(row.sendDate).format('YYYY/MM/DD');
    }
  }

  private updateDateFormatter(row: Message) {
    if (!row.updateDate) {
      return '';
    } else {
      return (this as any).$moment(row.updateDate).format('YYYY/MM/DD H:mm');
    }
  }

  private onMessageClick(row: Message) {
    this.$router.push({
      name: 'MessageDetails',
      params: {
        messageId: row.id
      }
    });
  }

  private onMoreClick() {
    const condition: SearchCondition = JSON.parse(
      JSON.stringify(this.condition)
    );
    condition.dateFrom = null;
    condition.dateTo = null;
    this.$router.push({
      name: 'MessageList',
      params: {
        searchCondition: JSON.stringify(condition)
      }
    });
  }
}
